import React, { useEffect, useState } from "react";
import EditIcon from "../../assets/icons/edit.svg";
import DeleteIcon from "../../assets/icons/delete.svg";
import MenuIcon from "../../assets/icons/menu.svg";

import Sidebar from "../../components/Sidebar/Sidebar";
import { categoryService } from "../../services/category.service";

import "./CategoriesAdmin.css";
import "../../utils/animate.css";
import ModalAddCategory from "../../components/ModalAddCategory/ModalAddCategory";
import ModalEditCategory from "../../components/ModalEditCategory/ModalEditCategory";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import { closeModal, showModal } from "../../utils/functions/modal";

const CategoriesAdmin = () => {
  const [categories, setCategories] = useState(undefined);
  const [categoryEdit, setCategoryEdit] = useState();
  const [idCategory, setIdCategory] = useState();
  const [message, setMessage] = useState(undefined);

  const getAllCategories = async () => {
    const response = await categoryService.getAllCategories();
    if (response.status === 200) {
      setCategories(response.data);
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  const showSidebar = () => {
    document
      .querySelector(".container-sidebar")
      ?.classList.add("show-sidebar");
  };

  const showModalEditCategory = (category) => {
    setCategoryEdit(category);
    showModal(".container-modal-edit-category");
  };

  const showModalDelete = (category) => {
    showModal(".container-modal-confirm");

    setIdCategory(category.id);
    setMessage({
      description: `¿Estás seguro de eliminar la categoría "${category.nombre}"?`,
      status: 300,
      action: deleteCategory,
    });
  };

  const deleteCategory = async (id) => {
    setMessage({
      description: "Eliminando categoría...",
      status: 1000,
    });
    const response = await categoryService.deleteCategory(id);
    setTimeout(async () => {
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
      if (response.data.status === 200) {
        await getAllCategories();
      }
      setTimeout(() => {
        closeModal(".container-modal-confirm");
      }, 2000);
    }, 1500);
  };

  return (
    <>
      <ModalConfirm
        message={message}
        actionConfirm={message?.action}
        idSale={idCategory}
      />

      <ModalEditCategory
        setMessage={setMessage}
        category={categoryEdit}
        onSuccess={getAllCategories}
      />
      <ModalAddCategory setMessage={setMessage} onSuccess={getAllCategories} />

      <div className="container-categories-admin">
        <Sidebar />
        <div className="categories-admin">
          <div className="head-admin">
            <button className="btn-menu" onClick={() => showSidebar()}>
              <img src={MenuIcon} alt="" />
            </button>
            <h1 className="animate fadeIn">CATEGORÍAS</h1>
            <button
              onClick={() => showModal(".container-modal-add-category")}
              className="btn-add-product animate fadeIn"
            >
              AGREGAR
            </button>
          </div>

          <div className="table-categories">
            {categories && categories.length > 0 && (
              <table cellSpacing="0">
                <thead className="head-table animate fadeIn">
                  <tr>
                    <th>N°</th>
                    <th>Nombre</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category, key) => (
                    <tr
                      key={category.id}
                      style={{ animationDelay: `${Math.min(key, 8) * 0.06}s` }}
                    >
                      <td>{category.id}</td>
                      <td>{category.nombre}</td>
                      <td>
                        <button
                          className="action"
                          onClick={() => showModalEditCategory(category)}
                        >
                          <img src={EditIcon} alt="" />
                        </button>
                        <button
                          className="action"
                          onClick={() => showModalDelete(category)}
                        >
                          <img src={DeleteIcon} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {categories && categories.length === 0 && (
              <div className="empty-categories">
                <p>No hay categorías cargadas</p>
              </div>
            )}
            {categories === undefined && (
              <div className="empty-categories"></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoriesAdmin;
